
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6.5 4.5a3.5 3.5 0 117 0V5h.034c.67 0 1.223 0 1.675.03.47.033.904.101 1.322.274a4 4 0 012.165 2.165c.173.418.241.852.273 1.321.015.214.022.45.026.71h.505a3.5 3.5 0 110 7H19v.741c0 .805 0 1.47-.044 2.01-.046.563-.145 1.08-.392 1.565a4 4 0 01-1.748 1.748c-.485.247-1.002.346-1.564.392-.541.044-1.206.044-2.01.044H12.5a1 1 0 01-1-1v-1.75a1.25 1.25 0 10-2.5 0V22a1 1 0 01-1 1H6.759c-.805 0-1.47 0-2.01-.044-.563-.046-1.08-.145-1.565-.392a4 4 0 01-1.748-1.748c-.247-.485-.346-1.002-.392-1.564C1 18.71 1 18.046 1 17.242V15.5a1 1 0 011-1h1.5a1.5 1.5 0 000-3H2a1 1 0 01-1-1v-.034c0-.67 0-1.223.03-1.676.033-.469.101-.903.274-1.32A4 4 0 013.47 5.303c.418-.173.852-.241 1.321-.273C5.243 5 5.796 5 6.466 5H6.5v-.5zM10 3a1.5 1.5 0 00-1.5 1.5V6a1 1 0 01-1 1h-1c-.713 0-1.197 0-1.573.026-.368.025-.559.07-.692.126a2 2 0 00-1.083 1.083c-.055.133-.1.324-.126.692-.011.166-.018.354-.021.573H3.5a3.5 3.5 0 110 7H3v.7c0 .857 0 1.439.038 1.889.035.438.1.663.18.819a2 2 0 00.874.874c.156.08.38.145.819.18C5.361 21 5.943 21 6.8 21H7v-.75a3.25 3.25 0 016.5 0V21c.696 0 1.194-.005 1.589-.038.438-.035.663-.1.819-.18a2 2 0 00.874-.874c.08-.156.145-.38.18-.819.037-.45.038-1.032.038-1.889v-1.7a1 1 0 011-1h1.5a1.5 1.5 0 000-3H18a1 1 0 01-1-1c0-.713 0-1.197-.026-1.573-.025-.368-.07-.559-.126-.692a2 2 0 00-1.083-1.083c-.133-.055-.324-.1-.692-.126C14.697 7.001 14.213 7 13.5 7h-1a1 1 0 01-1-1V4.5A1.5 1.5 0 0010 3z","fill":"#fff"}})])
          )
        }
      }
    